module.exports = "/_next/static/images/si-c2844c75e37b9fff4e68af2d1f8ed4cf.svg";